document.documentElement.classList.remove('no-js');

const nvLanguage = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
const nvCopy = {
  it: { viewCart: 'Vedi carrello', adding: 'Aggiungo…', added: 'Prodotto aggiunto alla dispensa.', add: 'Aggiungi', addPantry: 'Aggiungi alla dispensa', soldOut: 'Esaurito', available: 'Disponibile', unavailable: 'Temporaneamente esaurito', save: 'Risparmi il', wishlistAdd: 'Aggiungi', wishlistRemove: 'Rimuovi', wishlistProduct: 'prodotto', wishlistFrom: 'dalla', wishlistTo: 'alla', wishlistName: 'lista dei desideri', wishlistSaved: 'Salvato', wishlistSave: 'Salva', discover: 'Scopri', productSingular: 'prodotto', productPlural: 'prodotti' },
  en: { viewCart: 'View cart', adding: 'Adding…', added: 'Product added to the pantry.', add: 'Add', addPantry: 'Add to the pantry', soldOut: 'Sold out', available: 'Available', unavailable: 'Temporarily unavailable', save: 'Save', wishlistAdd: 'Add', wishlistRemove: 'Remove', wishlistProduct: 'product', wishlistFrom: 'from', wishlistTo: 'to', wishlistName: 'wishlist', wishlistSaved: 'Saved', wishlistSave: 'Save', discover: 'Discover', productSingular: 'product', productPlural: 'products' },
  de: { viewCart: 'Warenkorb ansehen', adding: 'Wird hinzugefügt…', added: 'Produkt zur Speisekammer hinzugefügt.', add: 'Hinzufügen', addPantry: 'In die Speisekammer legen', soldOut: 'Ausverkauft', available: 'Verfügbar', unavailable: 'Vorübergehend nicht verfügbar', save: 'Du sparst', wishlistAdd: 'Zur Wunschliste hinzufügen:', wishlistRemove: 'Von der Wunschliste entfernen:', wishlistProduct: 'Produkt', wishlistFrom: 'aus', wishlistTo: 'zur', wishlistName: 'Wunschliste', wishlistSaved: 'Gemerkt', wishlistSave: 'Merken', discover: 'Entdecken', productSingular: 'Produkt', productPlural: 'Produkte' }
}[nvLanguage] || { viewCart: 'Vedi carrello', adding: 'Aggiungo…', added: 'Prodotto aggiunto alla dispensa.', add: 'Aggiungi', addPantry: 'Aggiungi alla dispensa', soldOut: 'Esaurito', available: 'Disponibile', unavailable: 'Temporaneamente esaurito', save: 'Risparmi il', wishlistAdd: 'Aggiungi', wishlistRemove: 'Rimuovi', wishlistProduct: 'prodotto', wishlistFrom: 'dalla', wishlistTo: 'alla', wishlistName: 'lista dei desideri', wishlistSaved: 'Salvato', wishlistSave: 'Salva', discover: 'Scopri', productSingular: 'prodotto', productPlural: 'prodotti' };

const menuButton = document.querySelector('[data-menu-toggle]');
if (menuButton) menuButton.addEventListener('click', () => {
  const open = document.body.classList.toggle('menu-open');
  menuButton.setAttribute('aria-expanded', String(open));
});

const toast = document.querySelector('[data-nv-toast]');
let toastTimer;
function showToast(message) {
  if (!toast) return;
  toast.innerHTML = `${message} <a href="${window.NVTheme.cartUrl}">${nvCopy.viewCart}</a>`;
  toast.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { toast.hidden = true; }, 4200);
}

document.querySelectorAll('[data-quick-add]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = nvCopy.adding;
    try {
      const response = await fetch(`${window.NVTheme.cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch(`${window.NVTheme.cartUrl}.js`).then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      if (form.closest('.nv-cart-upsell')) {
        window.location.reload();
        return;
      }
      showToast(nvCopy.added);
    } catch (error) {
      form.submit();
      return;
    } finally {
      button.disabled = false;
      button.textContent = original;
    }
  });
});

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const rail = carousel.querySelector('[data-carousel-rail]');
  const previous = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!rail) return;
  const move = (direction) => rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.78, 280), behavior: 'smooth' });
  if (previous) previous.addEventListener('click', () => move(-1));
  if (next) next.addEventListener('click', () => move(1));
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const select = section.querySelector('[data-variant-select]');
  const current = section.querySelector('[data-product-price-current]');
  const compare = section.querySelector('[data-product-price-compare]');
  const discount = section.querySelector('[data-product-discount]');
  const sticky = section.querySelector('[data-product-sticky]');
  const stickyPrice = section.querySelector('[data-product-sticky-price]');
  const stickySubmit = section.querySelector('[data-sticky-submit]');
  const mainAdd = section.querySelector('[data-main-add]');
  const productForm = section.querySelector('[data-product-form]');
  const availability = section.querySelector('[data-product-availability]');
  const stockMessage = section.querySelector('[data-product-stock]');
  const quantity = section.querySelector('[data-product-quantity]');
  const gallery = section.querySelector('[data-product-gallery]');
  const productWishlist = section.querySelector('.nv-wishlist-button--product');

  if (select) select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const discountValue = Number(option.dataset.discount || 0);
      const available = option.dataset.available === 'true';
      if (current) current.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = discountValue <= 0;
      }
      if (discount) {
        discount.textContent = discountValue > 0 ? `${nvCopy.save} ${discountValue}%` : '';
        discount.hidden = discountValue <= 0;
      }
      if (mainAdd) { mainAdd.disabled = !available; mainAdd.textContent = available ? nvCopy.addPantry : nvCopy.soldOut; }
      if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = available ? nvCopy.add : nvCopy.soldOut; }
      if (availability) availability.classList.toggle('is-unavailable', !available);
      if (stockMessage) stockMessage.textContent = option.dataset.stock || (available ? nvCopy.available : nvCopy.unavailable);
      if (quantity) {
        if (option.dataset.max) {
          quantity.max = option.dataset.max;
          quantity.value = String(Math.min(Number(quantity.value || 1), Number(option.dataset.max)));
        } else {
          quantity.removeAttribute('max');
        }
        quantity.disabled = !available;
      }
      if (productWishlist) productWishlist.dataset.wishlistPrice = option.dataset.price || productWishlist.dataset.wishlistPrice;
      if (option.dataset.mediaId && gallery) gallery.dispatchEvent(new CustomEvent('nv:select-media', { detail: { mediaId: option.dataset.mediaId } }));
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', variantUrl);
    });

  if (stickySubmit && productForm) stickySubmit.addEventListener('click', () => productForm.requestSubmit());
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-active', !entry.isIntersecting), { threshold: 0.2 });
    stickyObserver.observe(mainAdd);
  }
});

const cartForm = document.querySelector('[data-cart-form]');
if (cartForm) {
  const updateButton = cartForm.querySelector('[data-cart-update]');
  let cartUpdateTimer;
  const updateCart = () => {
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => {
      if (!updateButton) return;
      updateButton.disabled = true;
      updateButton.textContent = 'Aggiorno…';
      cartForm.requestSubmit(updateButton);
    }, 420);
  };

  cartForm.querySelectorAll('[data-cart-line]').forEach((line) => {
    const input = line.querySelector('[data-cart-quantity-input]');
    const minus = line.querySelector('[data-cart-quantity-minus]');
    const plus = line.querySelector('[data-cart-quantity-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min || 0), Number(input.value || 0) - 1));
      updateCart();
    });
    plus?.addEventListener('click', () => {
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Number(input.value || 0) + 1));
      updateCart();
    });
    input.addEventListener('change', () => {
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Math.max(Number(input.min || 0), Number(input.value || 0))));
      updateCart();
    });
  });
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const currentLabel = gallery.querySelector('[data-gallery-current]');
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
  let currentIndex = 0;
  let touchStartX = 0;
  let suppressZoomUntil = 0;

  const showImage = (nextIndex) => {
    if (!slides.length) return;
    currentIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const active = index === currentIndex;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach((thumb, index) => {
      const active = index === currentIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', String(active));
    });
    if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
    if (dialog?.open && dialogImage) {
      const image = slides[currentIndex].querySelector('img');
      dialogImage.src = image?.src || '';
      dialogImage.alt = image?.alt || '';
    }
  };

  currentIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
  showImage(currentIndex);
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.galleryIndex))));
  gallery.querySelectorAll('[data-gallery-prev]').forEach((button) => button.addEventListener('click', () => showImage(currentIndex - 1)));
  gallery.querySelectorAll('[data-gallery-next]').forEach((button) => button.addEventListener('click', () => showImage(currentIndex + 1)));
  gallery.querySelectorAll('[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
    if (Date.now() < suppressZoomUntil) return;
    if (!dialog || !dialogImage) return;
    const image = slides[currentIndex]?.querySelector('img');
    dialogImage.src = image?.src || '';
    dialogImage.alt = image?.alt || '';
    dialog.showModal();
    document.body.classList.add('nv-modal-open');
  }));
  gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog?.addEventListener('close', () => document.body.classList.remove('nv-modal-open'));
  const stage = gallery.querySelector('.nv-product-gallery__stage');
  stage?.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX || 0; }, { passive: true });
  stage?.addEventListener('touchend', (event) => {
    const touchEndX = event.changedTouches[0]?.clientX || 0;
    const distance = touchEndX - touchStartX;
    if (Math.abs(distance) < 45 || slides.length < 2) return;
    suppressZoomUntil = Date.now() + 450;
    showImage(currentIndex + (distance < 0 ? 1 : -1));
  }, { passive: true });
  gallery.addEventListener('nv:select-media', (event) => {
    const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(event.detail.mediaId));
    if (mediaIndex >= 0) showImage(mediaIndex);
  });
});

document.querySelectorAll('product-recommendations').forEach(async (element) => {
  const loadRecommendations = async (url) => {
    if (!url) return false;
    const response = await fetch(url);
    if (!response.ok) return false;
    const text = await response.text();
    const documentFragment = new DOMParser().parseFromString(text, 'text/html');
    const source = documentFragment.querySelector('product-recommendations');
    if (!source || !source.innerHTML.trim()) return false;
    element.innerHTML = source.innerHTML;
    return true;
  };
  try {
    const loaded = await loadRecommendations(element.dataset.recommendationsUrl);
    if (!loaded) await loadRecommendations(element.dataset.fallbackUrl);
  } catch (error) {
    // La pagina prodotto resta completa anche se i suggerimenti non sono disponibili.
  }
});

const wishlistStorageKey = 'nv-wishlist-v1';
const wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
const wishlistOverlay = document.querySelector('[data-wishlist-overlay]');
const wishlistItems = document.querySelector('[data-wishlist-items]');
const wishlistEmpty = document.querySelector('[data-wishlist-empty]');
const accountWishlistItems = document.querySelector('[data-account-wishlist-items]');
const accountWishlistEmpty = document.querySelector('[data-account-wishlist-empty]');
const accountWishlistCount = document.querySelector('[data-account-wishlist-count]');
let wishlist = [];

const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
}[character]));

try {
  const storedWishlist = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
  if (Array.isArray(storedWishlist)) wishlist = storedWishlist;
} catch (error) {
  wishlist = [];
}

function saveWishlist() {
  try { localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist)); } catch (error) {}
}

function syncWishlistButtons() {
  const handles = new Set(wishlist.map((item) => item.handle));
  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const active = handles.has(button.dataset.wishlistHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', `${active ? nvCopy.wishlistRemove : nvCopy.wishlistAdd} ${button.dataset.wishlistTitle || nvCopy.wishlistProduct} ${active ? nvCopy.wishlistFrom : nvCopy.wishlistTo} ${nvCopy.wishlistName}`);
    const label = button.querySelector('[data-wishlist-label]');
    if (label) label.textContent = active ? nvCopy.wishlistSaved : nvCopy.wishlistSave;
  });
  document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
    counter.textContent = String(wishlist.length);
    counter.hidden = wishlist.length === 0;
  });
}

function renderWishlist() {
  if (wishlistItems && wishlistEmpty) {
    wishlistItems.innerHTML = wishlist.map((item) => `
      <article class="nv-wishlist-item">
        <a href="${escapeHTML(item.url)}" class="nv-wishlist-item__image">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy">` : ''}</a>
        <div>
          <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.title)}</strong></a>
          <span>${escapeHTML(item.price)}</span>
          <button type="button" data-wishlist-remove="${escapeHTML(item.handle)}">${nvCopy.wishlistRemove}</button>
        </div>
      </article>
    `).join('');
    wishlistEmpty.hidden = wishlist.length > 0;
  }

  if (accountWishlistItems && accountWishlistEmpty) {
    accountWishlistItems.innerHTML = wishlist.map((item) => `
      <article class="nv-account-wishlist__item">
        <a href="${escapeHTML(item.url)}" class="nv-account-wishlist__image">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy">` : ''}</a>
        <div>
          <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
          <span>${escapeHTML(item.price)}</span>
          <footer>
            <a href="${escapeHTML(item.url)}">${nvCopy.discover}</a>
            <button type="button" data-wishlist-remove="${escapeHTML(item.handle)}">${nvCopy.wishlistRemove}</button>
          </footer>
        </div>
      </article>
    `).join('');
    accountWishlistEmpty.hidden = wishlist.length > 0;
  }

  if (accountWishlistCount) {
    accountWishlistCount.textContent = `${wishlist.length} ${wishlist.length === 1 ? nvCopy.productSingular : nvCopy.productPlural}`;
  }
}

function openWishlist() {
  if (!wishlistDrawer || !wishlistOverlay) return;
  renderWishlist();
  wishlistOverlay.hidden = false;
  wishlistDrawer.classList.add('is-open');
  wishlistDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('nv-drawer-open');
  wishlistDrawer.querySelector('[data-wishlist-close]')?.focus();
}

function closeWishlist() {
  if (!wishlistDrawer || !wishlistOverlay) return;
  wishlistDrawer.classList.remove('is-open');
  wishlistDrawer.setAttribute('aria-hidden', 'true');
  wishlistOverlay.hidden = true;
  document.body.classList.remove('nv-drawer-open');
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');
  if (toggle) {
    event.preventDefault();
    const handle = toggle.dataset.wishlistHandle;
    const existingIndex = wishlist.findIndex((item) => item.handle === handle);
    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
      showToast('Prodotto rimosso dai desideri.');
    } else {
      wishlist.unshift({
        handle,
        title: toggle.dataset.wishlistTitle || '',
        url: toggle.dataset.wishlistUrl || '#',
        image: toggle.dataset.wishlistImage || '',
        price: toggle.dataset.wishlistPrice || ''
      });
      wishlist = wishlist.slice(0, 50);
      showToast('Prodotto salvato nei desideri.');
    }
    saveWishlist();
    syncWishlistButtons();
    renderWishlist();
    return;
  }

  const remove = event.target.closest('[data-wishlist-remove]');
  if (remove) {
    wishlist = wishlist.filter((item) => item.handle !== remove.dataset.wishlistRemove);
    saveWishlist();
    syncWishlistButtons();
    renderWishlist();
  }
});

document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', openWishlist));
document.querySelectorAll('[data-wishlist-close]').forEach((button) => button.addEventListener('click', closeWishlist));
wishlistOverlay?.addEventListener('click', closeWishlist);
document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && wishlistDrawer?.classList.contains('is-open')) closeWishlist(); });
syncWishlistButtons();
renderWishlist();

document.querySelectorAll('[data-predictive-search]').forEach((search) => {
  const input = search.querySelector('[data-predictive-search-input]');
  const results = search.querySelector('[data-predictive-search-results]');
  const reset = search.querySelector('[data-predictive-search-reset]');
  if (!input || !results) return;
  let searchTimer;
  let searchController;

  const closeResults = () => {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  };

  const formatPrice = (price) => {
    const amount = Number(price);
    if (Number.isNaN(amount)) return price || '';
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const runSearch = async () => {
    const query = input.value.trim();
    reset.hidden = query.length === 0;
    if (query.length < 2) {
      closeResults();
      return;
    }
    searchController?.abort();
    searchController = new AbortController();
    results.hidden = false;
    results.innerHTML = '<p class="nv-smart-search__loading">Cerchiamo nella dispensa…</p>';
    input.setAttribute('aria-expanded', 'true');
    try {
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(endpoint, { signal: searchController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('predictive-search');
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        results.innerHTML = `<p class="nv-smart-search__loading">Nessun prodotto trovato per “${escapeHTML(query)}”.</p>`;
        return;
      }
      results.innerHTML = `
        <div class="nv-smart-search__grid" role="listbox">
          ${products.map((product) => `
            <a class="nv-smart-search__item" href="${escapeHTML(product.url)}" role="option">
              <span>${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy">` : ''}</span>
              <div><small>${escapeHTML(product.vendor || 'Nero Vesuviano')}</small><strong>${escapeHTML(product.title)}</strong><b>${escapeHTML(formatPrice(product.price))}</b></div>
              <i aria-hidden="true">→</i>
            </a>
          `).join('')}
        </div>
        <a class="nv-smart-search__all" href="/search?q=${encodeURIComponent(query)}">Vedi tutti i risultati per “${escapeHTML(query)}” →</a>
      `;
    } catch (error) {
      if (error.name !== 'AbortError') results.innerHTML = '<p class="nv-smart-search__loading">La ricerca non è disponibile. Premi Invio per cercare.</p>';
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(runSearch, 220);
  });
  input.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeResults(); });
  reset?.addEventListener('click', () => {
    input.value = '';
    reset.hidden = true;
    closeResults();
    input.focus();
  });
  document.addEventListener('click', (event) => { if (!search.contains(event.target)) closeResults(); });
});

document.querySelectorAll('[data-editorial-stream]').forEach((stream) => {
  const cards = Array.from(stream.querySelectorAll('[data-editorial-grid] > .nv-editorial-card'));
  const button = stream.querySelector('[data-editorial-more]');
  const status = stream.querySelector('[data-editorial-status]');
  const batch = Number(stream.dataset.editorialBatch) || 4;
  let visibleCards = Math.min(batch, cards.length);

  if (!button || cards.length <= batch) return;

  const syncEditorialCards = (announce = false) => {
    cards.forEach((card, index) => { card.hidden = index >= visibleCards; });
    button.hidden = visibleCards >= cards.length;
    button.setAttribute('aria-expanded', String(visibleCards >= cards.length));
    if (announce && status) {
      const messages = {
        it: `Ora sono visibili ${visibleCards} articoli su ${cards.length}.`,
        en: `${visibleCards} of ${cards.length} articles are now visible.`,
        de: `${visibleCards} von ${cards.length} Artikeln sind jetzt sichtbar.`
      };
      status.textContent = messages[nvLanguage] || messages.it;
    }
  };

  button.hidden = false;
  button.addEventListener('click', () => {
    visibleCards = Math.min(visibleCards + batch, cards.length);
    syncEditorialCards(true);
  });
  syncEditorialCards();
});

const footerDetails = document.querySelectorAll('.nv-footer__column');
const footerBreakpoint = window.matchMedia('(max-width: 900px)');
function syncFooterDetails(event) {
  footerDetails.forEach((detail) => { detail.open = !event.matches; });
}
if (footerDetails.length) {
  syncFooterDetails(footerBreakpoint);
  footerBreakpoint.addEventListener('change', syncFooterDetails);
}

if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  // Alcuni template, come la pagina Shop, sono composti da un'unica sezione
  // molto alta. Una soglia elevata impedirebbe all'animazione di attivarsi.
  }), { threshold: 0.01 });
  document.querySelectorAll('main > .shopify-section').forEach((section) => { section.classList.add('nv-reveal'); observer.observe(section); });
}
